import { useRouter } from 'next/router';
import NProgress from 'nprogress';
import { useEffect } from 'react';

enum LoadingState {
  Active,
  Inactive,
}

export default function TopProgressBar() {
  const router = useRouter();

  useEffect(() => {
    let state: LoadingState = LoadingState.Inactive;

    function load() {
      if (state === LoadingState.Active) {
        return;
      }

      state = LoadingState.Active;
      NProgress.start();
    }

    function stop() {
      state = LoadingState.Inactive;
      NProgress.done();
    }

    router.events.on('routeChangeStart', load);
    router.events.on('routeChangeComplete', stop);
    router.events.on('routeChangeError', stop);
    NProgress.configure({ showSpinner: false });

    return () => {
      router.events.off('routeChangeStart', load);
      router.events.off('routeChangeComplete', stop);
      router.events.off('routeChangeError', stop);
    };
  }, [router]);

  return null;
}
